// extracted by mini-css-extract-plugin
export default {"EmailVerificationScreen":"EmailVerificationScreen_EmailVerificationScreen__ym8Vk","CodeInput":"EmailVerificationScreen_CodeInput__D+MZc"};